import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateMeasLaboratoryPrescriptionDocumentInput,
  useChGenerateMeasLaboratoryPrescriptionMutation as useChGenerateMeasLaboratoryPrescriptionMutationType,
} from "@/modules/patients/detail/meas-laboratory-prescription/ch/services/__generated__/useChGenerateMeasLaboratoryPrescriptionMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const mutation = graphql`
  mutation useChGenerateMeasLaboratoryPrescriptionMutation(
    $input: Ch_generateMeasLaboratoryPrescriptionDocumentInput!
  ) {
    ch_generateMeasLaboratoryPrescriptionDocument(input: $input) {
      ch_MeasLaboratoryPrescription {
        id
        fileId
        ...chMeasLaboratoryPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateMeasLaboratoryPrescriptionMutationType>, "variables"> & {
  id: string
  uploadSessionCode?: Ch_generateMeasLaboratoryPrescriptionDocumentInput["uploadSessionCode"]
}

const useChGenerateMeasLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChGenerateMeasLaboratoryPrescriptionMutationType>(
    mutation,
    params,
  )
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: { id: config.id, patientId: patientById, uploadSessionCode: config.uploadSessionCode },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateMeasLaboratoryPrescriptionMutation }
